import React from 'react';
import OtherVisitsTable from './Components/OtherVisitsTable';

const OtherVisitsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <OtherVisitsTable />
      </div>
    </div>
  );
};

export default OtherVisitsPage;
